module.exports = __webpack_public_path__ + "static/media/10D.15a4b086.svg";